<template>
  <v-container id="dashboard" fluid class="dash-page">

    <!-- Background Sama Seperti Login -->
    <div class="dash-bg">
      <div class="dash-gradient"></div>
      <div class="dash-pattern"></div>
    </div>

    <v-row>
      <v-col cols="12">
        <base-material-tabs
          v-model="tab"
          background-color="transparent"
          color="warning"
          icons-and-text
        >
          <v-tab v-for="(t, i) in tabs" :key="i">
            {{ t.text }}
            <v-icon v-text="t.icon" />
          </v-tab>

          <v-tabs-items v-model="tab" class="pt-10 transparent">
            <v-tab-item>

              <!-- Hero Card -->
              <v-card class="hero-card" elevation="12">
                <v-card-text>

                  <div class="hero-title">
                    Informasi Presensi Pegawai
                  </div>

                  <div class="hero-subtitle">
                    Ketentuan presensi elektronik sesuai Nota Dinas ND-1317/PB.1/2025.
                  </div>

                  <div class="cta-wrapper">
                    <v-btn
                      class="btn-primary"
                      large
                      rounded
                      to="/wfh/absen"
                    >
                      <v-icon left>mdi-fingerprint</v-icon>
                      Buka Absen
                    </v-btn>
<!--
                    <v-btn
                      class="btn-secondary"
                      large
                      rounded
                      outlined
                      to="/repwork/list"
                    >
                      <v-icon left>mdi-clipboard-check-outline</v-icon>
                      Laporan Pekerjaan
                    </v-btn>
-->
                    
                  </div>

                </v-card-text>
              </v-card>

              <!-- Content Card -->
              <v-card class="content-card mt-6" elevation="12">
                <v-card-text class="info-text">
                  <v-alert
                    type="info"
                    colored-border
                    border="left"
                    elevation="0"
                    class="mb-4"
                  >
                    Ringkasan poin penting pengaturan presensi:
                  </v-alert>

                  <ol class="info-list text-justify">
                    <li>
                      <strong>Presensi Elektronik</strong>
                        <p>
                          Seluruh pegawai wajib melakukan presensi secara elektronik menggunakan aplikasi <b>Satu Kemenkeu versi mobile</b>, sesuai Surat Edaran Menteri Keuangan Nomor SE-6/MK.1/2023.
                        </p>
                    </li>

                    <li>
                      <strong>Pembatasan Radius Presensi</strong>
                      <p>
                        Mulai 1 Mei 2025, presensi (clock-in dan clock-out) dibatasi dalam radius:
                      <ol type="a">
                        <li>
                          <b>1000 meter</b> dari lokasi unit kerja untuk Kantor Pusat dan Kantor Vertikal di DKI Jakarta.
                        </li>
                        <li>
                          <b>500 meter</b> untuk Kantor Vertikal lainnya.
                        </li>
                      </ol>
                      </p>
                    </li>

                    <li>
                      <strong>Pengajuan Izin</strong>
                      <p>
                        <ol type="a">
                          <li>
                            Permohonan izin (tidak masuk, terlambat, pulang cepat, dll.) harus diajukan secara online melalui modul kehadiran di <b>Satu Kemenkeu</b>.
                          </li>
                          <li>
                            Pengajuan izin wajib dilakukan paling lambat <b>3 hari kerja</b> setelah ketidakhadiran.
                          </li>
                        </ol>
                      </p>
                    </li>

                    <li>
                      <strong>Sistem Kerja Fleksibel</strong>
                      <p>
                          Untuk pegawai dengan penugasan fleksibel, pengelola SDM unit kerja wajib merekam penugasan tersebut di aplikasi Satu Kemenkeu agar status presensi menyesuaikan.
                      </p>
                    </li>

                    <li>
                      <strong>Peran Pimpinan</strong>
                      <p>
                            Pimpinan unit/satker bertanggung jawab melakukan sosialisasi, pengawasan, dan memberikan keteladanan terkait ketentuan ini.
                      </p>
                    </li>
                  </ol>

                </v-card-text>
              </v-card>

            </v-tab-item>
          </v-tabs-items>
        </base-material-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DashboardPanels",
  data: () => ({
    tab: 0,
    tabs: [
      { text: "Informasi", icon: "mdi-information" }
    ]
  })
};
</script>

<style scoped>

/* ===== Background Sama dengan Login ===== */

.dash-page {
  position: relative;
  min-height: calc(100vh - 64px);
  overflow: hidden;
}

.dash-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.dash-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(1000px 650px at 15% 20%, rgba(245,131,43,0.15), transparent 60%),
    radial-gradient(900px 650px at 85% 10%, rgba(31,86,48,0.30), transparent 60%),
    linear-gradient(135deg, #1F5630 0%, #352F36 100%);
}

.dash-pattern {
  position: absolute;
  inset: 0;
  background-image: url("~@/assets/bpdp-icon-pack.svg");
  background-repeat: repeat;
  background-size: 200px;
  opacity: 0.06;
  filter: grayscale(100%);
  mix-blend-mode: overlay;
}

#dashboard > * {
  position: relative;
  z-index: 1;
}

/* ===== Hero Card ===== */

.hero-card {
  border-radius: 20px;
  background: linear-gradient(
    90deg,
    rgba(31,86,48,0.98),
    rgba(245,131,43,0.92)
  );
  color: #FFFFFF;
}

.hero-title {
  font-size: 22px;
  font-weight: 800;
  color: white;
}

.hero-subtitle {
  margin-top: 6px;
  opacity: 0.9;
  font-size: 13px;
  color: white;
}

.cta-wrapper {
  margin-top: 18px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-primary {
  background: #F5832B !important;
  color: #FFFFFF !important;
  box-shadow: 0 10px 22px rgba(245,131,43,0.35);
}

.btn-secondary {
  background: transparent !important;
  border: 2px solid #F5832B !important;   /* Green BPDP */
  color: #FFFFFF !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.btn-secondary:hover {
  background: rgba(31,86,48,0.08) !important;
}

/* ===== Content Card ===== */

.content-card {
  border-radius: 20px;
  background: #FFFFFF;
}

.info-text {
  color: #352F36;
  font-size: 14px;
}

</style>